import { render, staticRenderFns } from "./CorreoRestablecido.vue?vue&type=template&id=9a40ae9e&scoped=true&"
import script from "./CorreoRestablecido.vue?vue&type=script&lang=js&"
export * from "./CorreoRestablecido.vue?vue&type=script&lang=js&"
import style0 from "./CorreoRestablecido.vue?vue&type=style&index=0&id=9a40ae9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a40ae9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VIcon})
